


function resolveInternalPath(raw?: string): string | null {
    const path = raw?.trim();
    if (!path) return null;

    // Off-origin, or a scheme (`javascript:`, `https:`) dressed as a path.
    if (!path.startsWith("/")) return null;
    if (path.startsWith("//") || path.startsWith("/\\")) return null;

    // A newline or NUL inside a path is never legitimate, but is a standard way
    // to smuggle one parser's terminator past another's.
    if (/[\u0000-\u001F\u007F]/.test(path)) return null;

    return path;
}

export function resolveStartAction(params: Record<string, string>): string | null {
    switch (params.type) {
        case "course": {
            if (!params.id) return null;
            const query = params.miniapp_id
                ? `?miniAppUuid=${encodeURIComponent(params.miniapp_id)}`
                : "";
            return `/course/${params.id}${query}`;
        }

        case "page":
            return resolveInternalPath(params.path);
        default:
            return null;
    }
}


export function getRawStartParam(): string | undefined {
    if (typeof window === "undefined") return undefined;

    const fromUrl = new URLSearchParams(window.location.search).get("tgWebAppStartParam");
    return fromUrl ?? window.Eitaa?.WebApp?.initDataUnsafe?.start_param ?? undefined;
}

function encodeBase64Url(value: string): string {
    const bytes = new TextEncoder().encode(value);
    let binary = "";
    for (const byte of bytes) binary += String.fromCharCode(byte);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}


export function encodeStartParams(
    params: Record<string, string | number | undefined | null>,
): string {
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== null && value !== "") {
            search.set(key, String(value));
        }
    }
    return encodeBase64Url(search.toString());
}

function safeDecodeURIComponent(value: string): string | undefined {
    try {
        return decodeURIComponent(value);
    } catch {
        return undefined;
    }
}

function decodeBase64Url(value: string): string | undefined {
    if (typeof atob === "undefined") return undefined;
    try {
        const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
        const bytes = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
        return new TextDecoder().decode(bytes);
    } catch {
        return undefined;
    }
}


export function parseStartParams(raw?: string): Record<string, string> {
    const value = raw ?? getRawStartParam();
    if (!value) return {};

    const candidates = [decodeBase64Url(value), safeDecodeURIComponent(value), value];
    for (const candidate of candidates) {
        if (!candidate) continue;
        const out: Record<string, string> = {};
        for (const [key, val] of new URLSearchParams(candidate)) {
            if (val) out[key] = val;
        }
        if (Object.keys(out).length) return out;
    }

    return {};
}